<template>
  <div class="container platform-config-page">
    <div class="title">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>平台建设</el-breadcrumb-item>
        <el-breadcrumb-item>配置管理</el-breadcrumb-item>
        <el-breadcrumb-item>派单SLA</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="title-en">派单SLA</div>
    <el-card class="box-card">
      <el-table
        :data="tableData"
        style="width: 100%"
        :header-cell-style="headerStyle"
        :row-class-name="tableRowClassName"
      >
        <el-table-column prop="ip3" align="center" width="180">
          <template slot="header">
            <div>获取到的tp3</div>
            <div>字段的值</div>
          </template>
        </el-table-column>
        <el-table-column prop="slaLevel" align="center" width="180">
          <template slot="header">
            <div>SLAlevel值：PO列表</div>
            <div>中"工单等级"</div>
            <div>显示值</div>
          </template>
        </el-table-column>
        <el-table-column prop="slaResponse" align="center" width="180">
          <template slot="header">
            <div>SLAlevel值：PO时效</div>
            <div>中"响应与分派SLA"显</div>
            <div>示值</div>
          </template>
        </el-table-column>
        <el-table-column align="left" min-width="400">
          <template slot="header">
            <div>备注（tp3的数值的含义）</div>
          </template>
          <template slot-scope="scope">
            <div class="remark-content">
              <div v-for="num in getNumbers(scope.row.ip3)" :key="num" class="remark-item">
                {{ findOpDescription(num) }}
              </div>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      headerStyle: {
        background: '#4e71be',
        color: '#fff',
        fontWeight: 'bold',
        textAlign: 'center',
      },
      tableData: [
        {
          ip3: '1、2、3、4、37、38、39、40、41',
          slaLevel: '1: 一级\n2: 二级\n3: 三级',
          slaResponse: '1、2、3: 120分钟',
        },
        {
          ip3: '5、6',
          slaLevel: '1: 一级\n2: 二级\n3: 三级',
          slaResponse: '1: 30分钟\n2: 60分钟\n3: 120分钟',
        },
        {
          ip3: '7',
          slaLevel: '0: 重要\n1: 一级\n2: 二级\n3: 三级',
          slaResponse: '0: 5分钟\n1、2、3: 60分钟',
        },
        {
          ip3: '8',
          slaLevel: '1: 一级\n2: 二级\n3: 三级',
          slaResponse: '1、2、3: 60分钟',
        },
        {
          ip3: '9、10、11、12、13、14、28、29、34、35、36、42',
          slaLevel: '1: 一级\n2: 二级\n3: 三级',
          slaResponse: '1、2、3: 120分钟',
        },
        {
          ip3: '15、36、38',
          slaLevel: '1: 一级\n2: 二级\n3: 三级',
          slaResponse: '1、2、3: 24小时',
        },
      ],
      allOps: [
        '1. 搬迁',
        '2. 退役',
        '3. TPC',
        '4. 直配',
        '5. 故障排查',
        '6. 故障维修',
        '7. 网络诊断与故障排查',
        '8. 现场支持',
        '9. ≤2U',
        '10. >2U&≤8U',
        '11. >8U',
        '12. 端口及模块操作',
        '13. 网络链路调试',
        '14. ODF链路操作',
        '15. 零星链路布放与移撤',
        '16. 网络整机',
        '17. 网络部件',
        '18. 服务器整机',
        '19. 服务器部件',
        '20. 按箱物资',
        '21. 线材',
        '22. 网络整机',
        '23. 网络部件',
        '24. 服务器整机',
        '25. 服务器部件',
        '26. 按箱物资',
        '27. 线材',
        '28. IDC现场监管',
        '29. IDC机房巡检',
        '30. 北上广深',
        '31. 省会&直辖',
        '32. 其他城市',
        '33. 边远地区',
        '34. 网络设备现场操作',
        '35. 布线工程复检',
        '36. 机架线缆规撤',
        '37. 改造',
        '38. 部件拆解',
        '39. 部件测试',
        '40. 硬盘处置',
        '41. 机柜出库',
        '42. 运维按次服务',
      ],
    };
  },
  methods: {
    tableRowClassName({ rowIndex }) {
      return rowIndex % 2 === 0 ? 'even-row' : 'odd-row';
    },
    getNumbers(ip3) {
      return ip3.split('、').map(Number);
    },
    findOpDescription(num) {
      const item = this.allOps.find((op) => {
        const opNum = parseInt(op.split('.')[0]);
        return opNum === num;
      });
      return item || '';
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  padding: 20px;
}
.title {
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 30px;
}
.title-en {
  margin: 10px 0;
  padding-left: 10px;
  border-left: 3px solid #219aff;
  font-weight: normal;
}
.box-card {
  margin-bottom: 20px;
}

.remark-content {
  padding: 8px;
  display: flex;
  flex-wrap: wrap; // 允许换行
  gap: 20px;

  .remark-item {
    line-height: 1.5;
    margin-bottom: 8px;
    font-size: 14px;
    min-height: 21px;
    height: 20px;
    flex: 0 0 auto; // 不伸缩，保持原始大小
    width: 200px; // 设置固定宽度
    overflow: hidden; // 超出隐藏
    text-overflow: ellipsis; // 显示省略号
    white-space: nowrap; // 不换行
  }
}

::v-deep .el-table {
  th.el-table__cell {
    background-color: #4e71be !important;
    border: 0.5px solid #fff;
    .cell {
      white-space: pre-line;
      line-height: 1.5;
      color: #fff;
      padding: 8px;
    }
  }
  th.el-table__cell:first-child {
    border: 0.5px solid #fff;
  }
  .el-table__header {
    border-color: #fff;
  }
  td.el-table__cell {
    border: 0.5px solid #fff;
    .cell {
      white-space: pre-line;
      line-height: 1.5;
    }
  }
  td.el-table__cell:first-child {
    background-color: #4e71be !important;
    color: #fff;
  }
  tr:hover > td.el-table__cell:first-child {
    background-color: #4e71be !important;
  }
}

::v-deep .el-table .even-row {
  background-color: #ced4e8;
}

::v-deep .el-table .odd-row {
  background-color: #e9ebf3;
}
</style>